import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
	disabledLink: PropTypes.bool,
	sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
	const theme = useTheme();
	const PRIMARY_LIGHT = theme.palette.primary.light;
	const PRIMARY_MAIN = theme.palette.primary.main;
	const PRIMARY_DARK = theme.palette.primary.dark;
	const logo = (
		<Box sx={{ width: 40, height: 40, ...sx }}>
			<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 679.000000 657.000000" >
				<defs>
					<linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
						<stop offset="0%" stopColor={PRIMARY_DARK} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
				</defs>
				<g
					fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,657.000000) scale(0.100000,-0.100000)" >


<path d="M1514 3857 c-3 -8 -4 -148 -2 -311 l3 -298 24 -19 c23 -19 74 -25
119 -13 22 6 22 8 22 179 0 190 -2 185 64 185 66 0 70 -11 76 -182 3 -84 8
-158 13 -165 11 -17 63 -26 114 -18 l45 7 -4 176 c-5 199 -13 232 -70 276 -37
27 -124 49 -164 41 -13 -3 -35 -7 -49 -10 -25 -5 -25 -4 -25 60 0 87 -17 105
-100 105 -41 0 -62 -4 -66 -13z"/>
<path d="M1151 3824 c-83 -22 -140 -69 -180 -147 -30 -58 -34 -76 -35 -144 -2
-129 38 -219 119 -275 56 -38 118 -53 210 -52 82 1 127 15 155 49 20 24 17 80
-4 104 -18 19 -20 19 -50 4 -41 -22 -131 -22 -174 0 -65 35 -94 124 -72 216
26 108 134 150 243 94 26 -13 31 -13 48 3 28 25 25 84 -5 113 -50 47 -155 62
-255 35z"/>
<path d="M3885 3829 c-40 -5 -81 -17 -95 -28 l-25 -18 -3 -240 c-1 -139 2
-252 7 -266 6 -15 24 -33 41 -42 46 -24 165 -36 245 -24 172 24 265 133 265
309 0 90 -22 158 -69 211 -48 55 -106 85 -191 98 -73 12 -77 12 -175 0z m189
-157 c45 -26 66 -76 66 -155 0 -101 -30 -148 -107 -165 -23 -5 -53 -7 -67 -5
l-26 5 0 168 c0 152 2 169 18 173 27 8 84 -3 116 -21z"/>
<path d="M4968 3813 l-28 -4 0 -228 c0 -280 9 -314 89 -348 46 -20 156 -19
187 2 28 18 40 58 28 94 -8 23 -13 25 -57 22 -70 -4 -77 6 -77 105 l0 84 48 0
c71 0 94 20 90 78 l-3 47 -67 3 -68 3 0 48 c0 32 -6 56 -17 69 -19 21 -77 33
-125 25z"/>
<path d="M5460 3720 c-56 -7 -99 -24 -112 -44 -12 -18 -9 -71 5 -89 11 -14 17
-15 67 -1 64 16 109 18 145 4 23 -9 43 -35 34 -45 -3 -2 -45 -9 -94 -15 -149
-20 -195 -58 -195 -159 0 -83 57 -134 171 -152 116 -19 255 22 280 82 18 44 8
285 -14 326 -40 76 -149 111 -287 93z m138 -332 l-3 -43 -48 -3 c-52 -3 -77 9
-77 39 0 22 13 31 60 40 70 14 71 13 68 -33z"/>
<path d="M2263 3709 c-152 -29 -227 -171 -177 -338 19 -67 76 -123 147 -147
99 -34 261 -13 287 37 14 25 12 62 -4 84 -13 18 -15 18 -74 1 -39 -12 -76 -17
-103 -13 -41 5 -89 32 -96 53 -2 6 53 18 128 29 165 23 183 34 177 111 -11
127 -140 211 -285 183z m107 -139 c11 -11 20 -24 20 -29 0 -7 -115 -31 -149
-31 -19 0 -12 30 14 55 31 32 86 34 115 5z"/>
<path d="M2757 3710 c-74 -10 -111 -35 -115 -81 -2 -19 3 -42 10 -51 12 -15
18 -16 68 -2 64 16 109 18 145 4 23 -9 43 -35 34 -45 -3 -2 -45 -9 -94 -15
-148 -20 -195 -58 -195 -156 0 -102 79 -158 225 -157 99 0 156 15 198 53 l32
28 0 149 c0 161 -8 190 -61 232 -46 36 -150 54 -247 41z m141 -332 l-3 -43
-48 -3 c-52 -3 -77 9 -77 39 0 22 13 31 60 40 70 14 71 13 68 -33z"/>
<path d="M3310 3706 c-67 -15 -116 -40 -130 -65 -6 -12 -10 -122 -10 -283 0
-288 2 -300 58 -311 15 -3 47 -3 70 0 l42 6 0 81 0 81 67 -3 c83 -5 133 9 180
51 64 56 92 153 74 253 -21 110 -90 174 -211 193 -76 13 -70 13 -140 -3z m135
-132 c39 -15 60 -130 34 -187 -12 -27 -47 -47 -84 -47 -53 0 -55 4 -55 119 0
59 3 111 7 114 8 9 76 9 98 1z"/>
<path d="M4466 3705 c-21 -7 -43 -20 -47 -27 -13 -20 -11 -72 4 -91 11 -14 17
-15 67 -1 64 16 109 18 145 4 23 -9 43 -35 33 -45 -2 -2 -43 -9 -92 -15 -144
-18 -196 -58 -196 -150 0 -68 24 -106 87 -137 49 -23 67 -27 147 -26 106 1
163 19 202 66 26 31 26 32 22 172 -6 181 -25 219 -127 253 -46 16 -197 14
-245 -3z m202 -317 l-3 -43 -48 -3 c-52 -3 -77 9 -77 39 0 22 13 31 60 40 70
14 71 13 68 -33z"/>
<path d="M5444 2596 c-11 -28 1 -89 17 -91 8 -2 62 0 120 4 l104 6 -1 30 c-3
71 7 65 -119 65 -90 0 -117 -3 -121 -14z"/>
<path d="M4414 2586 c-3 -8 -4 -31 -2 -52 3 -37 5 -39 36 -38 17 0 72 1 121 2
l89 2 -3 33 c-2 17 -4 40 -4 50 -1 15 -13 17 -116 17 -90 0 -117 -3 -121 -14z"/>
<path d="M4754 2586 c-3 -8 -4 -31 -2 -52 3 -36 5 -39 33 -38 17 1 71 2 120 3
l90 1 -2 37 c-1 21 -2 44 -2 51 -1 19 -230 17 -237 -2z"/>
<path d="M5104 2586 c-3 -8 -4 -31 -2 -52 l3 -39 115 4 c63 2 118 6 121 10 3
3 4 25 1 49 l-4 42 -114 0 c-89 0 -116 -3 -120 -14z"/>
<path d="M3034 2576 c-3 -8 -4 -31 -2 -52 l3 -39 120 4 c66 2 121 4 122 5 0 0
-1 22 -4 49 l-6 47 -114 0 c-88 0 -115 -3 -119 -14z"/>
<path d="M3374 2576 c-3 -8 -4 -31 -2 -52 l3 -39 120 4 c66 2 121 4 123 6 1 1
-1 23 -4 48 l-7 47 -114 0 c-88 0 -115 -3 -119 -14z"/>
<path d="M3724 2576 c-3 -8 -4 -31 -2 -52 l3 -39 120 4 c66 2 121 5 123 6 2 2
0 24 -3 49 l-7 46 -114 0 c-89 0 -116 -3 -120 -14z"/>
<path d="M4064 2576 c-3 -8 -4 -31 -2 -52 l3 -39 120 4 c66 2 121 4 123 6 1 1
-1 23 -4 48 l-7 47 -114 0 c-88 0 -115 -3 -119 -14z"/>
<path d="M1994 2566 c-3 -8 -4 -31 -2 -52 l3 -39 120 4 c66 2 121 4 123 6 1 1
-1 23 -4 48 l-7 47 -114 0 c-88 0 -115 -3 -119 -14z"/>
<path d="M2344 2566 c-3 -8 -4 -31 -2 -52 l3 -39 120 4 c66 2 121 5 123 6 2 2
0 24 -3 49 l-7 46 -114 0 c-89 0 -116 -3 -120 -14z"/>
<path d="M2684 2566 c-3 -8 -4 -31 -2 -52 l3 -39 120 4 c66 2 121 4 122 5 0 0
-1 22 -4 49 l-6 47 -114 0 c-88 0 -115 -3 -119 -14z"/>
<path d="M964 2556 c-3 -8 -4 -31 -2 -52 l3 -39 115 4 c63 2 118 6 122 10 4 3
4 25 1 49 l-6 42 -114 0 c-88 0 -115 -3 -119 -14z"/>
<path d="M1304 2556 c-3 -8 -4 -31 -2 -52 l3 -39 120 4 c66 2 121 4 122 5 0 0
-1 22 -4 49 l-6 47 -114 0 c-88 0 -115 -3 -119 -14z"/>
<path d="M1654 2556 c-3 -8 -4 -31 -2 -52 l3 -39 120 4 c66 2 120 4 121 5 0 0
-1 22 -4 49 l-4 47 -114 0 c-89 0 -116 -3 -120 -14z"/>
</g>
</svg>


		</Box >
	);
	if (disabledLink) {
		return <>{logo}</>;
	}

	return <RouterLink to="">{logo}</RouterLink>;
}
